import {addGaEvent} from 'app/ga_methods';
import {userStore} from 'app/store/global';

export const sendGaFirstDepositEvent = (): void => {
    if (!userStore.user.first_deposit) {
        addGaEvent('First deposit', true);
    }
};
